import * as React from "react";

function SvgEmailAptitude(props, ref) {
  return (
    <svg
      id="EmailAptitude_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 293 152.8"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".EmailAptitude_svg__st0{fill:#8ab53e}.EmailAptitude_svg__st1{fill:#94d51f}"
        }
      </style>
      <path
        className="EmailAptitude_svg__st0"
        d="M288.9 87c0 20.5-8.3 39.1-21.8 52.6L214.5 87l52.6-52.6c13.5 13.5 21.8 32.1 21.8 52.6zM214.5 87l-52.6 52.6c-13.5-13.5-21.8-32-21.8-52.6s8.3-39.1 21.8-52.6L214.5 87zM75.7 1.8c20.5 0 39.1 8.3 52.6 21.8L75.7 76.1 23.1 23.5C36.6 10.1 55.2 1.8 75.7 1.8zM75.7 76.1l52.6 52.6c-13.5 13.5-32 21.8-52.6 21.8s-39.1-8.3-52.6-21.8l52.6-52.6z"
      />
      <g>
        <path
          className="EmailAptitude_svg__st1"
          d="M267.1 34.4L214.5 87l-52.6-52.6C175.4 21 194 12.6 214.5 12.6s39.1 8.4 52.6 21.8zM23.1 23.5l52.6 52.6-52.6 52.6C9.7 115.2 1.3 96.6 1.3 76.1S9.7 37 23.1 23.5z"
        />
        <path
          transform="rotate(-45.001 102.85 76.119)"
          className="EmailAptitude_svg__st1"
          d="M83.7 56.9h38.4v38.4H83.7z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgEmailAptitude);
